import Middleware from './Middleware';

class Access extends Middleware {
    run(props, next) {
        const permission = props.permission;
        const module = props.module;

        const location = this.location.pathname + this.location.search;

        let hasAccess = true;

        if (module) {
            if (this.user) {
                if (!this.user.module(module)) {
                    hasAccess = false;
                }
            } else {
                hasAccess = false;
            }
        }

        if (hasAccess) {
            if (permission) {
                if (this.user) {
                    if (!this.user.hasAny(permission)) {
                        hasAccess = false;
                    }
                } else {
                    hasAccess = false;
                }
            }
        }

        if (!hasAccess) {
            return this.redirectWithState('/unauthorized', {
                from: location,
                module: module || '',
                permission: permission || ''
            });
        }

        return next(this.app);
    }
}

export default Access;